import styled, { css } from "styled-components";

export const Container = styled.div`
    display: flex;
    background-color: #ffffff;
    //min-height: 100vh;
    width: 100%;
    flex: 1;
    height: max-content;
    padding-bottom: 10px;
`

export const PreviewHeader = styled.div`
    display: flex;
    background-color: ${props => props.backgroundColor};
    height: 60px;
    width: 100%;
    justify-content: center;
    align-items: center;

    label{
        color: ${props => props.color};
        font-size: 18px;
    }
`

export const PreviewTitle = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 20px 0px;

    label{
        color: ${props => props.color};
        font-size: 18px;
        opacity: 0.5;
    }

    p{
        color: ${props => props.color};
        font-size: 32px;
        margin: 0px;
        padding: 0px;
    }

`

export const PreviewBody = styled.div`
    display: flex;
    background-color: ${props => props.backgroundColor};
    width: 100%;
    flex-direction: column;
    height: max-content;
    border-radius: 4px;
    
`

export const PreviewProducts = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px 20px;
 
`

export const PreviewCard = styled.div`
    display: flex;
    min-height: 80px;
    background-color: ${props => props.backgroundColor};
    border-radius: 8px;
    align-items: center;
    padding: 0px 20px;
    justify-content: space-between;

    label{
        color: ${props => props.color};
    }

    span{
        display: flex;
        min-width: 120px;
        height: 40px;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        background-color: ${props => props.backgroundColorButton};

        label{
            font-size: 13px;
            color: ${props => props.colorButton};
        }
    }
`

export const AlertSave = styled.div`
    background-color: #242527 ;
    display: flex ;
    width: 700px ;
    bottom: 100px;
    position: fixed ;
    height: 60px ;
    align-items: center ;
    padding: 0px 10px ;
    border-radius: 4px ;
    gap: 10px;

    img{
        width: 44px ;
        height: 44px ;
    }

    span{
        display: flex ;
        flex: 1;
        //background-color: yellow ;
        justify-content: space-between ;

        label{
            font-size: 14px ;
            display: flex ;
            align-items: center ;
            font-size: 14px ;
            color: #fff;

        }

        div{
            display: flex ;
            gap: 10px;
            align-items: center ;

            label{
                font-size: 14px ;
                height: 35px ;
                border: 1px solid #FFFFFF;
                border-radius: 4px;
                display: flex ;
                align-items: center ;
                padding: 0px 10px ;
                color: white ;
                font-size: 14px  !important;
                cursor: pointer;
            }

            span{
                background-color: #00803B ;
                border: none ;
                outline: none ;
                cursor: pointer;
                height: 35px ;
                border-radius: 4px ;
                width: 90px ;
                color: white ;
                font-size: 14px ;
                display: flex ;
                align-items: center ;
                justify-content: center ;
            }
        }
    }
`

export const BoxActive = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    span{
        display: flex;
        //background-color: red;
        align-items: center;
        justify-content: space-between;

        img{
            margin-right: 10px;
        }
        
    }

`

export const ItemActive = styled.div`
    display: flex;
    width: 30px;
    height: 20px;
    background-color: ${props => props.active ? "#111827" : "gray"};
    align-items: center;
    padding: 0px 5px;
    border-radius: 5px;
    justify-content: ${props => props.active ? "right" : "left"};
    cursor: pointer;

    span{
        display: flex;
        height: 10px;
        width: 10px;
        background-color: white;
        border-radius: 2px;
    }
`

// Cartão do seletor de posição (fundo claro com bordas suaves)
export const PositionBox = styled.div`
  display: flex;
  width: 100%;
  background: #f9fafb; /* mais próximo do mock */
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
`

// Grid 3x3 para as áreas clicáveis
export const PositionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 56px);
  gap: 10px;
  width: 100%;
`

// Cada célula clicável
export const PositionCell = styled.button`
  position: relative;
  --corner-color: ${props => (props.selected ? '#111827' : '#d1d5db')};
  border: 1px dotted ${props => (props.selected ? '#111827' : '#d1d5db')};
  background: #ffffff;
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
  outline: none;
  transition: box-shadow .15s ease, border-color .15s ease;

  /* cantos em formato de "L" usando múltiplas camadas de background */
  background-image:
    /* topo-esquerda */
    linear-gradient(var(--corner-color), var(--corner-color)),
    linear-gradient(var(--corner-color), var(--corner-color)),
    /* topo-direita */
    linear-gradient(var(--corner-color), var(--corner-color)),
    linear-gradient(var(--corner-color), var(--corner-color)),
    /* baixo-esquerda */
    linear-gradient(var(--corner-color), var(--corner-color)),
    linear-gradient(var(--corner-color), var(--corner-color)),
    /* baixo-direita */
    linear-gradient(var(--corner-color), var(--corner-color)),
    linear-gradient(var(--corner-color), var(--corner-color));
  background-repeat: no-repeat;
  background-size:
    14px 2px, 2px 14px,
    14px 2px, 2px 14px,
    14px 2px, 2px 14px,
    14px 2px, 2px 14px;
  background-position:
    left 8px top 8px, left 8px top 8px,
    right 8px top 8px, right 8px top 8px,
    left 8px bottom 8px, left 8px bottom 8px,
    right 8px bottom 8px, right 8px bottom 8px;

  &:hover {
    box-shadow: 0 0 0 3px rgba(2, 6, 23, 0.06);
    //border-color: #111827;
    border: none;
    background-color: #111827;
  }

  /* Estado selecionado: fundo suave + borda sólida e leve anel externo */
  ${props => props.selected && css`
    background-image: none; /* remove cantos */
    background-color: #111827; /* cinza claro */
    border-color: #111827; /* borda sólida escura */
    box-shadow: 0 0 0 2px rgba(17, 24, 39, 0.12); /* anel sutil externo */
  `}
`

// Indicador escuro que representa a "pílula" selecionada
export const PositionIndicator = styled.div`
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  width: 80px;
  height: 24px;
  background: #111827; /* dark */
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.25);
`

// Slider de opacidade com preenchimento até o valor atual e visual refinado
export const OpacityRange = styled.input.attrs({ type: 'range' })`
  width: 100%;
  height: 8px !important;
  border-radius: 9999px;
  background: linear-gradient(#1b76ff, #1b76ff) 0/var(--val, 50%) 100% no-repeat, #e9ecef;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  padding: 0;
  margin: 0;
  box-sizing: border-box;

  /* WebKit */
  &::-webkit-slider-runnable-track {
    height: 8px;
    background: transparent; /* deixa o background do input visível */
    border-radius: 9999px;
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #1b76ff;
    cursor: pointer;
    margin-top: -4px; /* centraliza o thumb na trilha de 8px */
    border: 2px solid #ffffff;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    transition: box-shadow .2s ease, transform .2s ease;
  }
  &:hover::-webkit-slider-thumb {
    box-shadow: 0 0 0 6px rgba(27,118,255,0.12);
  }
  &:focus-visible::-webkit-slider-thumb {
    box-shadow: 0 0 0 6px rgba(27,118,255,0.18);
  }

  /* Firefox */
  &::-moz-range-track {
    height: 8px;
    background: #e9ecef;
    border-radius: 9999px;
  }
  &::-moz-range-progress {
    height: 8px;
    background: #1b76ff;
    border-radius: 9999px;
  }
  &::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #1b76ff;
    border: 2px solid #ffffff;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    cursor: pointer;
    transition: box-shadow .2s ease, transform .2s ease;
  }
  &:hover::-moz-range-thumb {
    box-shadow: 0 0 0 6px rgba(27,118,255,0.12);
  }
  &:focus-visible::-moz-range-thumb {
    box-shadow: 0 0 0 6px rgba(27,118,255,0.18);
  }
`